import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "tab-list-booking",
  class: "bg-gray-lp-1000 px-3 flex h-full flex-col gap-4",
  style: {"padding-top":"10px"}
}
const _hoisted_2 = { class: "grid grid-cols-4 gap-4 w-full bg-white items-center rounded-lg px-3 py-2" }
const _hoisted_3 = { class: "col-span-2" }
const _hoisted_4 = {
  class: "px-4 py-1 flex flex-row items-center rounded-lg w-full",
  style: {"background-color":"#D8EEFB","box-shadow":"0px 1px 4px 0px rgba(26, 20, 33, 0.15)"}
}
const _hoisted_5 = { class: "text-14px font-normal font-montserrat text-blue-lp-700" }
const _hoisted_6 = { class: "col-span-2 flex flex-row gap-4" }
const _hoisted_7 = { class: "bg-gray-lp-1000 pb-20 h-full" }
const _hoisted_8 = { class: "flex flex-col h-full bg-white rounded-lg overflow-hidden" }
const _hoisted_9 = { class: "flex flex-row p-4 border border-b space-x-4" }
const _hoisted_10 = { class: "hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Notification = _resolveComponent("Notification")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_Icons, {
              width: "24",
              height: "24",
              class: "mr-2",
              name: "warning-circle",
              color: "#2468F6"
            }),
            _withDirectives(_createVNode("p", _hoisted_5, null, 512), [
              [_directive_sanitize_html, _ctx.$t('bookingCbp.bannerSearchClientFirst')]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_SelectSearchV2, {
            onFilter: _ctx.onSearchListPosCbp,
            onFocus: _ctx.onSearchListPosCbp,
            isLoading: _ctx.isLoadingPosCbp,
            options: _ctx.posCbp,
            keyName: "name",
            keyValue: "id",
            placeholder: _ctx.$t('bookingCbp.placeholderSearchClient'),
            modelValue: _ctx.filter.pmcClientId,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.pmcClientId = $event)),
              _ctx.onSelectPosCbp
            ]
          }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"]),
          (_ctx.isAbleCreateManifest)
            ? (_openBlock(), _createBlock(_component_LpButton, {
                key: 0,
                customClass: "px-6",
                small: "",
                disabled: _ctx.disabledCreateManifest,
                textColor: "white",
                onClick: _ctx.onPrintManifest,
                title: _ctx.$t('bookingCbp.buttonCreateManifest')
              }, null, 8, ["disabled", "onClick", "title"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusPrintManifest, (tab) => {
              return (_openBlock(), _createBlock("div", {
                key: tab.label,
                class: 
              `
          rounded-lg
          text-14px
          xxl:text-16px
          py-2
          px-4
          text-center
          items-center
          self-center
          font-montserrat
          ${
            _ctx.isTabActive(tab.value)
              ? 'bg-red-lp-100 text-white'
              : 'bg-white border border-gray-lp-300 text-gray-lp-300'
          }
          cursor-pointer
          whitespace-nowrap
        `
            ,
                onClick: ($event: any) => (_ctx.changeStatusPrintManifest(tab.value))
              }, _toDisplayString(tab.label), 11, ["onClick"]))
            }), 128))
          ]),
          _createVNode(_component_TableV2, {
            loading: _ctx.apiListData.loading,
            borderTop: false,
            borderBottom: false,
            columns: _ctx.columns,
            data: _ctx.listData.data,
            isEmpty: _ctx.isEmpty,
            emptyHeaderMessage: _ctx.$t('bookingCbp.emptyListMessage'),
            errorCause: _ctx.apiListData.errorType,
            onClick: ($event: any) => (
            {
            }
          ),
            isDetailAble: "",
            pagination: _ctx.listData.pagination,
            "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listData.pagination = $event)),
            onRequest: _ctx.getListClientCBP,
            onTryAgain: _ctx.getListClientCBP,
            paginationStyle: "v3",
            isPinnedScrollBottom: "",
            isSpaceTop: false,
            bgHeader: "bg-white",
            pinnedSubstractHeight: "320px",
            compactDesign: "",
            paginationV3PaddingVertical: "pb-2 px-4",
            customClassPagination: "w-full h-full flex items-end",
            isBorderOnHeadBgWhite: "",
            isNoPaddingBottom: ""
          }, null, 8, ["loading", "columns", "data", "isEmpty", "emptyHeaderMessage", "errorCause", "pagination", "onRequest", "onTryAgain"])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("img", {
          id: "logo",
          src: require(`@/app/ui/assets/images/logo-${_ctx.roleAccount}.png`),
          class: "hidden",
          alt: "logo"
        }, null, 8, ["src"])
      ])
    ]),
    _createVNode(_component_Notification, {
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.notification = $event)),
      isCustom: "",
      message: _ctx.copyStyles.message,
      customStyles: _ctx.copyStyles,
      isAutoDisplay: false,
      isAutoClose: "",
      timeout: 3,
      class: _ctx.copyStyles.width,
      showIconClose: false
    }, null, 8, ["modelValue", "message", "customStyles", "class"])
  ], 64))
}